// extracted by mini-css-extract-plugin
export default {"add_composition_process":"AddCompositionProcess_add_composition_process__kq9sy","title":"AddCompositionProcess_title__tPVuc","process_box":"AddCompositionProcess_process_box__aGZBK"};